module.exports = __webpack_public_path__ + "static/img/mobileBigNotes.6a4e8a2b.jpg";